export type City = {
    name: string;
    lat: number;
    lng: number;
};

export const cities: City[] = [
    {name: 'Москва', lat: 55.7558, lng: 37.6173},
    {name: 'Санкт-Петербург', lat: 59.9311, lng: 30.3609},
    {name: 'Новосибирск', lat: 55.0084, lng: 82.9357},
    {name: 'Екатеринбург', lat: 56.8389, lng: 60.6057},
    {name: 'Казань', lat: 55.8304, lng: 49.0661},
    {name: 'Челябинск', lat: 55.1644, lng: 61.4368},
    {name: 'Нижний Новгород', lat: 56.2965, lng: 43.9361},
    {name: 'Самара', lat: 53.2415, lng: 50.2212},
    {name: 'Омск', lat: 54.9885, lng: 73.3242},
    {name: 'Ростов-на-Дону', lat: 47.2357, lng: 39.7015}
];
